export enum MaterialKind {
  Thread = 'thread',
  Trimming = 'trimming',
  Galoon = 'galoon',
  Cord = 'cord',
  Tassel = 'tassel',
}

export const MATERIAL_KIND_LABELS: Record<
  MaterialKind,
  { singular: string; plural: string }
> = {
  [MaterialKind.Thread]: { singular: 'Thread', plural: 'Threads' },
  [MaterialKind.Trimming]: { singular: 'Trimming', plural: 'Trimmings' },
  [MaterialKind.Galoon]: { singular: 'Galoon', plural: 'Galoons' },
  [MaterialKind.Cord]: { singular: 'Cord', plural: 'Cords' },
  [MaterialKind.Tassel]: { singular: 'Tassel', plural: 'Tassels' },
};
